import Model from 'src/storage/base';
import { lang, openApp, userFullName } from 'src/helpers';
import { formatFileReq } from 'src/components/user/components';
import AlertManager from 'src/components/alert';
import { MCText } from 'src/components/basic';
import LANG_CONST from 'src/helpers/lang/const';
import React from 'react';

class SignupDoctorModel extends Model {
  id = 'SignupDoctorModel';

  apiConfig = {
    signupDoctor: {
      url: 'auth/signup',
      validation: {
        lastName: 'lastName',
        firstName: 'firstName',
        username: 'username',
        email: 'emailAddress',
        password: 'password',
        phoneNumber: 'phoneNumber',
        isDoctor: 'boolean'
      },
      cancellable: true
    }
  };

  signUpDoctor = (data = {}, cb, gid_token, inviteCode) => {
    let req = {
      email: data.email,
      username: data.username,
      phoneNumber: data.phoneNumber,
      password: data.password,
      lastName: data.lastName,
      firstName: data.firstName,
      birthday: data.birthday,
      gender: data.gender,
      inviteCode,
      gid_token,
      isDoctor: true
    };
    formatFileReq(req, data.avatar);
    this.api('signupDoctor', req, (err, data, success) => {
      if (success) {
        cb(true);
        openApp();
        this.emit('auth', data);

        if (data.user?.invitationUser) {
          AlertManager.popup(AlertManager.TYPES.MOBILE_INFO, {
            width: 450,
            title: (
              <MCText
                size={20}
                weight={500}
                label={LANG_CONST.notice.join_title}
                style={{ textAlign: 'center' }}
              />
            ),
            titleEx: (
              <MCText
                size={20}
                label={lang.t(LANG_CONST.notice.joined_clinic, {
                  name: userFullName(data.user?.invitationUser)
                })}
              />
            ),
            actionButton: {
              label: LANG_CONST.buttons.continue,
              action: (props) => props.hide()
            }
          });
        }
      } else {
        cb(false);
      }
    });
  };
}

const model = new SignupDoctorModel();
export default model;
